import { normalizeCoverage } from 'features/top-three-profiles/topThreeProfiles';
import { Badge, Card } from 'shared/components/Feedback';

export function ProfileCoverageCard({ coverage, t }) {
  const data = normalizeCoverage(coverage || {});
  const completeTone = data.isComplete ? 'success' : 'warning';

  return (
    <Card className="coverage-card" data-testid="profile-coverage">
      <h2>{t('profiles.coverageTitle')}</h2>
      <dl className="definition-grid">
        <div className="definition-row">
          <dt>{t('profiles.profilesCount')}</dt>
          <dd data-testid="coverage-profiles">{t('profiles.profilesFraction', { found: data.foundProfiles, expected: data.expectedProfiles })}</dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.complete')}</dt>
          <dd>
            <Badge tone={completeTone}>{data.complete}</Badge>
            <span className="sr-only">{t('profiles.complete')}</span>
          </dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.incomplete')}</dt>
          <dd>
            <Badge tone={data.incomplete > 0 ? 'warning' : 'success'}>{data.incomplete}</Badge>
            <span className="sr-only">{t('profiles.incomplete')}</span>
          </dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.missing.personalSummary')}</dt>
          <dd data-testid="coverage-missing-summaries">{data.missingPersonalSummaries}</dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.missing.growth')}</dt>
          <dd data-testid="coverage-missing-growth">{data.missingGrowth}</dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.missing.careerPath')}</dt>
          <dd data-testid="coverage-missing-career">{data.missingCareerPaths}</dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.missing.strength')}</dt>
          <dd>{data.missingStrengths}</dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.missing.skill')}</dt>
          <dd>{data.missingSkills}</dd>
        </div>
        <div className="definition-row">
          <dt>{t('profiles.coverageComplete')}</dt>
          <dd data-testid="coverage-complete-flag">
            <Badge tone={data.isComplete ? 'success' : 'warning'}>
              {data.isComplete ? t('workbook.yes') : t('workbook.no')}
            </Badge>
          </dd>
        </div>
      </dl>
      {!data.isComplete ? (
        <p className="warning-banner" role="status" data-testid="coverage-nonblocking-warning">
          {t('profiles.coverageIncompleteWarning')}
        </p>
      ) : null}
    </Card>
  );
}
